import React from 'react';
import { Box, Stack } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';

interface MonthRangePickerProps {
  startMonth: Dayjs | null;
  endMonth: Dayjs | null;
  onStartMonthChange: (date: Dayjs | null) => void;
  onEndMonthChange: (date: Dayjs | null) => void;
}

const MonthRangePicker: React.FC<MonthRangePickerProps> = ({
  startMonth,
  endMonth,
  onStartMonthChange,
  onEndMonthChange,
}) => {
  const today = dayjs(); // Get today's date
  const minDate = dayjs('2024-01-01'); // Minimum date: January 1st, 2024

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
        <DatePicker
          label="Start Month"
          value={startMonth}
          onChange={onStartMonthChange}
          views={['year', 'month']}
          openTo="month"
          // Start month cannot be before Jan 2024, after end month (if set), or in the future
          minDate={minDate}
          maxDate={endMonth && endMonth.isBefore(today) ? endMonth : today}
          format="MMM YYYY"
          slotProps={{
            textField: {
              size: 'small',
              fullWidth: true,
              inputProps: { readOnly: true } // Make the input read-only
            }
          }}
        />
        <DatePicker
          label="End Month"
          value={endMonth}
          onChange={onEndMonthChange}
          views={['year', 'month']}
          openTo="month"
          // End month cannot be before Jan 2024, before start month (if set), or in the future
          minDate={startMonth ? (startMonth.isAfter(minDate) ? startMonth : minDate) : minDate}
          maxDate={today}
          format="MMM YYYY"
          slotProps={{
            textField: {
              size: 'small',
              fullWidth: true,
              inputProps: { readOnly: true } // Make the input read-only
            }
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
};

export default MonthRangePicker;

